import { render, staticRenderFns } from "./FormPanels.vue?vue&type=template&id=15f6a239&scoped=true&"
import script from "./FormPanels.vue?vue&type=script&lang=js&"
export * from "./FormPanels.vue?vue&type=script&lang=js&"
import style0 from "./FormPanels.vue?vue&type=style&index=0&id=15f6a239&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6a239",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
